import TextNew from '@cartwhl/ui/base/TextNew';
import ChevronLeftIcon from '@cartwhl/ui/icons/ChevronLeftIcon';

import { useStore } from '../assetLibraryStore';
import {
  getAssetLibrarySubViewTitle,
  isAssetLibrarySubView,
} from '../assetLibraryView';

export interface AssetLibrarySubViewHeaderProps {
  embedded?: boolean;
}

export default function AssetLibrarySubViewHeader({
  embedded = false,
}: AssetLibrarySubViewHeaderProps) {
  const store = useStore();
  const { libraryView } = store.state;
  const title = getAssetLibrarySubViewTitle(libraryView);

  if (!title || !isAssetLibrarySubView(libraryView)) {
    return null;
  }

  return (
    <div className={`flex flex-col gap-2 ${embedded ? '' : 'gap-2'}`}>
      <div className="flex min-w-0 items-center gap-3">
        <button
          type="button"
          aria-label="Back to library"
          className="bg-secondary hover:bg-gray-30 dark:hover:bg-gray-60 flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-lg transition-colors"
          onClick={() => store.setLibraryView('all')}
        >
          <ChevronLeftIcon className="text-primary size-5" />
        </button>
        <TextNew
          as={embedded ? 'h2' : 'h1'}
          token="display/20/medium"
          leading="body"
          className="text-primary min-w-0 text-pretty"
        >
          {title}
        </TextNew>
      </div>
      {libraryView === 'trash' ? (
        <TextNew token="14/medium" className="text-tertiary pt-2 text-pretty">
          Items in the trash will be permanently deleted within 30 days.
        </TextNew>
      ) : null}
    </div>
  );
}
